import { type SanityBlogSettings } from '@data/sanity/queries/types/blog'
import { type Locale } from './language'
import { getPageUrl, PageType } from './routes'

/**
 * Gets blog canonical URL.
 */
export const getBlogCanonicalUrl = (
  pageType: PageType,
  slug: string,
  blogSettings?: SanityBlogSettings,
) => {
  // Check if blog inheritance is set
  if (!blogSettings?.inheritContent || !blogSettings?.sourceLocale) {
    return
  }

  const origin = window.location.origin
  const pageUrl = getPageUrl(
    blogSettings.sourceLocale as Locale,
    pageType,
    slug,
  )

  return `${origin}${pageUrl}`
}
